export default __webpack_public_path__ + "static/TSD_Meltwater_Graphs-2-0ec6ac9d4d26d31f892c7baadf157cdc.png";